module.exports = __webpack_public_path__ + "img/2-5.12317b73.svg";